import { IComment } from '@app/models/Comment'
import { ICurrentUserState } from '@app/store/modules/account'
import { List } from 'immutable'
import * as React from 'react'
import { commentActionCreators } from '../modules/feedItems'
import CommentListItem from './CommentListItem'

interface ICommentsListProps {
  items: List<IComment>
}

type CommentsListProps = ICommentsListProps &
  ICurrentUserState &
  typeof commentActionCreators

export default class CommentsList extends React.PureComponent<
  CommentsListProps
> {
  public render() {
    if (this.props.items.size === 0) {
      return null
    }

    return (
      <ul className='comments-list mx-0 my-2 p-0'>
        {this.props.items
          .map((item, itemIndex) => {
            if (!item || itemIndex === undefined) {
              return null
            }

            return (
              <CommentListItem
                beginEdit={this.props.beginEditComment}
                cancelEdit={this.props.cancelEditComment}
                deleteComment={this.props.deleteComment}
                key={item.id}
                item={item}
                saveEditComment={this.props.saveEditComment}
                setIsPublic={this.props.setEditCommentIsPublic}
                setMarkup={this.props.setEditCommentMarkup}
                toggleFavorite={this.props.toggleCommentFavorite}
                user={this.props.user}
              />
            )
          })
          .toJS()}
      </ul>
    )
  }
}
